export default __webpack_public_path__ + "static/media/hht2_ep20_speaking_01.9a0bae8b.png";